import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { GameItem } from 'src/app/apollo/models/base-models';
import { DialogClosePreviousUrl } from 'src/app/services/utils/dialog-close-previouse-url.service';
import { WINDOW } from '@ng-web-apis/common';

@Component({
  selector: 'app-missions-games',
  templateUrl: './missions-games.component.html',
  styleUrls: ['./missions-games.component.scss']
})
export class MissionGamesComponent implements OnInit {

  constructor(
    private router: Router,
    private returnUrlService: DialogClosePreviousUrl,
    @Inject(WINDOW) readonly windowRef: Window,
  ) { }

  @Input() game: GameItem;
  @Output() onGameSelect = new EventEmitter<GameItem>();


  ngOnInit(): void {
  }

  gameClicked() {
    this.returnUrlService.setUrl(this.router.url.split('/'), this.windowRef.scrollY);
    this.onGameSelect.emit(this.game)
  }

}
